import React, { FC, useCallback, useEffect } from 'react'
import { Layout } from 'components/Layout'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { ShopCompleteTemplate } from 'components/Templates'
import { initShop } from 'reducks/shop/operations'
import { push } from 'connected-react-router'
import { fetchStore, initStore } from 'reducks/store/operations'
import { db } from 'firebase/index'
import { getStoreName } from 'reducks/store/selectors'
import { initConfirm } from 'reducks/confirm/operations'

const ShopEditAccountComplete: FC = () => {
  const dispatch = useDispatch()

  const name = useSelector((state: State) => getStoreName(state))
  const path = useSelector((state: State) => state.router.location.pathname)

  const isCompletePage = /\/admin\/shops\/.+\/account\/complete/.test(path)
  const id = isCompletePage ? path.split('/admin/shops/')[1].split('/account/complete')[0] : undefined

  useEffect(() => {
    if (!id || name !== '') return
    dispatch(fetchStore(db.collection('stores').doc(id)))
  }, [])

  const backToAdminTop = useCallback(() => {
    dispatch(push('/admin/shops'))
    dispatch(initConfirm())
    dispatch(initShop())
    dispatch(initStore())
  }, [dispatch])

  if (!id) return <></>

  return (
    <Layout title={`完了 | ${name}の店舗アカウント情報の設定`}>
      <ShopCompleteTemplate
        iconPath={'/icon/done/shop.svg'}
        firstLabel={'店舗アカウント情報の'}
        secondLabel={'編集が完了しました'}
        backToTop={backToAdminTop}
      />
    </Layout>
  )
}

export default ShopEditAccountComplete
